import React, { useEffect, useState } from "react";
import axios from "axios";
import LeadHistoryModal from "./LeadHistoryModal";
import AgentNavBar from "./AgentNavBar";
import './Allleads.css'

const COLORS = {
    primary: "#8b306d",
    secondary: "#42987e",
    background: "#F9FAFB",
    white: "#FFFFFF",
    textDark: "#1F2937",
    textLight: "#6B7280",
    border: "#E5E7EB",
};

const AllLeads = ({ history }) => {
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [filterVisible, setFilterVisible] = useState(false);
    const [leads, setLeads] = useState([]);

    const [historyModalVisible, setHistoryModalVisible] = useState(false);
    const [selectedLeadId, setSelectedLeadId] = useState(null);

    useEffect(() => {
        fetchAgents();
        fetchLeads();
    }, []);

    const openHistoryModal = (leadId) => {
        setSelectedLeadId(leadId);
        setHistoryModalVisible(true);
    };

    const fetchLeads = async (agentId = null) => {
        const userData = localStorage.getItem("user");


        const user = JSON.parse(userData);   // ✅ Parse the string
        const userId = user?.id;

        console.log('userId', userId)
        const url = agentId
            ? `https://api.propertygalleria.in/master/api/api/leads/under/${userId}?agentId=${agentId}`
            : `https://api.propertygalleria.in/master/api/api/leads/under/${userId}`;

        const res = await axios.get(url);

        if (res.data.success) {
            setLeads(res.data.leads);
        }
    };

    const fetchAgents = async () => {
        const userData = localStorage.getItem("user");
        const user = JSON.parse(userData);   // ✅ Parse the string
        const userId = user?.id;
        const res = await axios.get(
            `https://api.propertygalleria.in/master/api/api/agent/under/${userId}`
        );

        if (res.data.success) {
            setAgents(res.data.agents);
        }
    };

    return (
        // <div style={{ background: COLORS.background, minHeight: "100vh", padding: 16 }}>
   
   <>
     <AgentNavBar />
        <div
            style={{
                background: COLORS.background,
                minHeight: "100vh",
                padding: 20,
                maxWidth: 1400,
                margin: "0 auto",
                marginTop:'10%'
            }}
        >

            {/* Header */}
            <div
                // style={{
                //   display: "flex",
                //   justifyContent: "space-between",
                //   alignItems: "center",
                //   marginBottom: 20,
                // }}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                    flexWrap: "wrap",
                    gap: 10,
                }}
            >
                {/* <button onClick={() => history.goBack?.()}>Back</button> */}

                <h2 style={{ margin: 0, color: COLORS.textDark }}>All Leads</h2>

                <button   className="view-details-btn" onClick={() => setFilterVisible(true)}>Filter</button>
            </div>

            {/* Selected Agent Badge */}
            {selectedAgent && (
                <div
                    // style={{
                    //     background: COLORS.white,
                    //     padding: "10px 14px",
                    //     borderRadius: 30,
                    //     display: "flex",
                    //     justifyContent: "space-between",
                    //     alignItems: "center",
                    //     marginBottom: 10,
                    //     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    //     width: '20px'
                    // }}
                    style={{
                        background: COLORS.white,
                        padding: "8px 14px",
                        borderRadius: 30,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 15,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    }}
                >
                    <span style={{ color: COLORS.primary, fontWeight: 600 }}>
                        {selectedAgent.full_name} - {selectedAgent.designation}
                    </span>

                    <button
                        onClick={() => {
                            setSelectedAgent(null);
                            fetchLeads();
                        }}
                    >
                        ✕
                    </button>
                </div>
            )}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: 16,
                }}
            >
                {/* Leads List */}
                {leads.map((item) => (
                    <div
                        key={item.id}
                        // style={{
                        //     background: COLORS.white,
                        //     borderRadius: 18,
                        //     padding: 16,
                        //     marginBottom: 14,
                        //     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                        // }}
                        style={{
                            background: COLORS.white,
                            borderRadius: 14,
                            padding: 14,
                            boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            transition: "0.2s",
                            border: "1px solid #f1f1f1",
                        }}
                    >
                        <div
                            //style={{ fontWeight: 700, color: COLORS.textDark }}
                            style={{
                                fontWeight: 700,
                                color: COLORS.textDark,
                                fontSize: 15,
                            }}
                        >
                            {item.investor_name}
                        </div>

                        <div style={{ color: COLORS.textLight, fontSize: 13, }}>
                            {item.investor_mobile}
                        </div>

                        <div
                            style={{
                                color: COLORS.primary,
                                fontWeight: 600,
                                marginTop: 6,
                                fontSize: 14,
                            }}
                        >
                            {item.property_title}
                        </div>

                        {/* <div style={{ color: COLORS.secondary, marginTop: 4 }}>
                            {item.investment_range} • {item.status}
                        </div> */
                        }

                        <div
                            style={{
                                marginTop: 6,
                                fontSize: 12,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span style={{ color: COLORS.secondary }}>
                                {item.investment_range}
                            </span>

                            <span
                                style={{
                                    background: "#ecfdf5",
                                    color: "#047857",
                                    padding: "3px 8px",
                                    borderRadius: 20,
                                    fontWeight: 600,
                                    fontSize: 11,
                                }}
                            >
                                {item.status}
                            </span>
                        </div>

                        <div style={{ color: COLORS.textLight, marginTop: 6, fontSize: 12, }}>
                            {new Date(item.created_at).toLocaleDateString()}
                        </div>

                        <button
                            // style={{
                            //     marginTop: 10,
                            //     background: COLORS.secondary,
                            //     color: "#fff",
                            //     border: "none",
                            //     padding: "6px 14px",
                            //     borderRadius: 20,
                            //     float: "right",
                            //     cursor: "pointer",
                            // }}

                            style={{
                                marginTop: 12,
                                background: COLORS.secondary,
                                color: "#fff",
                                border: "none",
                                padding: "7px 12px",
                                borderRadius: 8,
                                cursor: "pointer",
                                fontSize: 13,
                                alignSelf: "flex-end",
                            }}
                            onClick={() => openHistoryModal(item.id)}
                        >
                            History
                        </button>
                    </div>
                ))}
            </div>
            {/* Filter Modal */}
            {filterVisible && (
                <div
                    onClick={() => setFilterVisible(false)}
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.35)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        paddingTop: 100,
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: COLORS.white,
                            borderRadius: 20,
                            padding: 20,
                            width: 350,
                            maxHeight: 400,
                            overflowY: "auto",
                        }}
                    >
                        <h3>Select Associate</h3>

                        {agents.map((agent) => (
                            <div
                                key={agent.id}
                                onClick={() => {
                                    setSelectedAgent(agent);
                                    fetchLeads(agent.id);
                                    setFilterVisible(false);
                                }}
                                style={{
                                    padding: 10,
                                    borderBottom: "1px solid #eee",
                                    cursor: "pointer",
                                }}
                            >
                                <div style={{ fontWeight: 600 }}>
                                    {agent.full_name}
                                </div>
                                <div style={{ color: COLORS.secondary }}>
                                    {agent.designation}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* History Modal */}
            {historyModalVisible && (
                <LeadHistoryModal
                    leadId={selectedLeadId}
                    onClose={() => setHistoryModalVisible(false)}
                />
            )}
        </div>

        </>
    );
};

export default AllLeads;